import { AUTH_URL } from '../config';
import { createUserManager } from 'redux-oidc';

const config = {
  authority: AUTH_URL, // replace with real auth link based on environment
  client_id: 'refill-app',
  redirect_uri: `${window.location.origin}/callback`, // created callback file to finalize open ID loop
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession: true,
  response_type: 'id_token token',
  scope: 'openid profile internal_credential',
  extraQueryParams: {
    ui_locales: 'en',
    primaryColor: '1c1c1c',
    faviconUrl:
      'https://storage.googleapis.com/storage.intelligentfridges.com/selfly-favicon.ico',
    logoLink:
      'https://storage.googleapis.com/storage.intelligentfridges.com/selfly-logo.png',
  },
};

const manager = createUserManager(config);

export default manager;
